import { render, staticRenderFns } from "./EventCalenderExternalCustomer.vue?vue&type=template&id=0f20172f"
import script from "./EventCalenderExternalCustomer.vue?vue&type=script&lang=ts"
export * from "./EventCalenderExternalCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports